export default "__VITE_ASSET__Jc3ANHuItLy9rk7IiWFubg__"